import dateFormat from 'dateformat';
import {
  getAdvanceVotingDataFundname,
  getVoteCast,
  getManagementRecc,
  getSupport,
  getOutputField,
  advancedVotingDataSearchlist,
  getListProposalsAndCategories,
  getOutcome,
} from '../config/server-config';
import { IsInternalUser, dateToISOString } from './general-util';
import { API_CALL_SUCCESSFULL } from '../constants/NumberConstants';
import { VOTING } from '../constants/ProductConstants';
import api from '../api';

export const GetAdvanceVotingDataFundnameReq = async () => {
  try {
    const response = await api.post(getAdvanceVotingDataFundname, {});
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export const AdvancedVotingDataSearch = async (
  internal,
  companySearchId,
  investorSearchId,
  investorid,
  meetingType,
  sponsor,
  meetingStartDate,
  meetingEndDate,
  fundId,
  voteCast,
  support,
  managementRecc,
  supportMin,
  supportMax,
  proposalType,
  ShowVotingDetail,
  showInvestorVotingDetail,
  ShowVoteResults,
  ShowRationale,
  outcome,
  dataView,
) => {
  try {
    const meetingStartDateVal = meetingStartDate ? dateFormat(meetingStartDate, 'yyyy-mm-dd') : null; //new change
    const meetingEndDateVal = meetingEndDate ? dateFormat(meetingEndDate, 'yyyy-mm-dd') : null; //new change

    const token = localStorage.getItem('token');
    const response = await api.post(advancedVotingDataSearchlist, {
      internal: internal,
      companySearchId: companySearchId,
      investorSearchId: investorSearchId,
      investor_id: investorid,
      meetingType: meetingType,
      sponsor: sponsor,
      meetingStartDate: meetingStartDateVal,
      meetingEndDate: meetingEndDateVal,
      fundId: fundId,
      voteCast: voteCast,
      support: support,
      managementRecc: managementRecc,
      supportMin: supportMin,
      supportMax: supportMax,
      proposalType: proposalType,
      ShowVotingDetail: ShowVotingDetail,
      showInvestorVotingDetail: showInvestorVotingDetail,
      ShowVoteResults: ShowVoteResults,
      ShowRationale: ShowRationale,
      outcome: outcome,
      dataView: dataView,
      product_id: VOTING,
      token,
    });
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export const GetVoteCast = async () => {
  try {
    const response = await api.post(getVoteCast, {});
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export const GetSupport = async () => {
  try {
    const response = await api.post(getSupport, {});
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export const GetManagementRecc = async () => {
  try {
    const response = await api.post(getManagementRecc, {});
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export const GetOutcome = async () => {
  try {
    const response = await api.post(getOutcome, {});
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export const GetOutputField = async () => {
  try {
    const response = await api.post(getOutputField, {});
    if (response.status === API_CALL_SUCCESSFULL) {
      const isInternalUser = await IsInternalUser();
      if (isInternalUser) {
        return response.data;
      }
      const leftData = response && response?.data && response?.data?.filter((el) => el && el?.label !== 'Internal');
      return leftData;
    }
  } catch (e) {
    return false;
  }
};

export const GetListProposalsAndCategories = async () => {
  try {
    const response = await api.post(getListProposalsAndCategories, {});
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};
